/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Shipment } from './Shipment';
import {
    ShipmentFromJSON,
    ShipmentFromJSONTyped,
    ShipmentToJSON,
    ShipmentToJSONTyped,
} from './Shipment';
import type { PreBookingShipment } from './PreBookingShipment';
import {
    PreBookingShipmentFromJSON,
    PreBookingShipmentFromJSONTyped,
    PreBookingShipmentToJSON,
    PreBookingShipmentToJSONTyped,
} from './PreBookingShipment';

/**
 * 
 * @export
 * @interface GetShipmentsResponse
 */
export interface GetShipmentsResponse {
    /**
     * 
     * @type {Array<Shipment>}
     * @memberof GetShipmentsResponse
     */
    booked: Array<Shipment>;
    /**
     * 
     * @type {Array<PreBookingShipment>}
     * @memberof GetShipmentsResponse
     */
    quoted: Array<PreBookingShipment>;
    /**
     * Remind the customer to upload photos of their freight — their recent shipments are missing pickup photos
     * @type {boolean}
     * @memberof GetShipmentsResponse
     */
    showPhotoUploadReminder: boolean;
}

/**
 * Check if a given object implements the GetShipmentsResponse interface.
 */
export function instanceOfGetShipmentsResponse(value: object): value is GetShipmentsResponse {
    if (!('booked' in value) || value['booked'] === undefined) return false;
    if (!('quoted' in value) || value['quoted'] === undefined) return false;
    if (!('showPhotoUploadReminder' in value) || value['showPhotoUploadReminder'] === undefined) return false;
    return true;
}

export function GetShipmentsResponseFromJSON(json: any): GetShipmentsResponse {
    return GetShipmentsResponseFromJSONTyped(json, false);
}

export function GetShipmentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetShipmentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'booked': ((json['booked'] as Array<any>).map(ShipmentFromJSON)),
        'quoted': ((json['quoted'] as Array<any>).map(PreBookingShipmentFromJSON)),
        'showPhotoUploadReminder': json['showPhotoUploadReminder'],
    };
}

  export function GetShipmentsResponseToJSON(json: any): GetShipmentsResponse {
      return GetShipmentsResponseToJSONTyped(json, false);
  }

  export function GetShipmentsResponseToJSONTyped(value?: GetShipmentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booked': ((value['booked'] as Array<any>).map(ShipmentToJSON)),
        'quoted': ((value['quoted'] as Array<any>).map(PreBookingShipmentToJSON)),
        'showPhotoUploadReminder': value['showPhotoUploadReminder'],
    };
}

